import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";

function AccountRejected() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full p-8 text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-3 bg-gradient-to-r from-pink-500/10 to-transparent p-2 pr-6 rounded-full">
            <div className="bg-white p-1.5 rounded-full shadow-sm">
              <img src={logo} alt="logo" className="h-5" />
            </div>
            <div className="text-pink-600 font-semibold">Supplier Portal</div>
          </div>
        </div>

        {/* Icon */}
        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="fi fi-rr-shield-exclamation text-2xl text-red-500"></i>
        </div>

        {/* Content */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Account Application Rejected
        </h1>
        
        <div className="space-y-4 mb-8">
          <p className="text-gray-600">
            We regret to inform you that your supplier account application has not been approved at this time.
          </p>
          
          <div className="bg-red-50 p-4 rounded-xl">
            <p className="text-red-700 font-medium">
              Common reasons for rejection:
            </p>
            <ul className="text-sm text-red-600 mt-2 space-y-1">
              <li>• Incomplete business documentation</li>
              <li>• Invalid business registration</li>
              <li>• Insufficient travel industry experience</li>
              <li>• Quality standards not met</li>
            </ul>
          </div>

          <p className="text-gray-500 text-sm">
            You can submit a new application after addressing the issues. Our support team is available to help you understand the requirements better.
          </p>
        </div>

        {/* Actions */}
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-3">
            
            <Link
              to="/login"
              className="flex-1 px-6 py-3 text-sm font-medium text-pink-600 bg-pink-50 rounded-xl hover:bg-pink-100 transition-colors"
            >
              Return to Login
            </Link>
          </div>
          
          <p className="text-sm text-gray-500">
            Need assistance? <button onClick={() => window.location.href = '/support'} className="text-pink-600 hover:text-pink-700">Contact Support</button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AccountRejected; 